import React, {Component} from 'react'

// import styles
import './index.scss'

// Elements
import ModalHeader from '../../elements/modalHeader'
import BottomBar from '../../elements/bottomBar'

class InfoPopup extends Component {

  render () {
    let higher = this.props.higher ? 'higher' : ''
    return (
      <div className='confirm_Price_modal__wrapper'>
        <div className={'backdrop__modal ' + higher} />
        <div className='confirm__modal'>
          <div className='confirm__content'>
            <ModalHeader text={this.props.t(this.props.Hedder)} />
            <div className='pg-pb-2'>{this.props.t(this.props.Text)}</div>
          </div>
          <BottomBar
            actionLabelText={this.props.t('956')}
            onActionClick={this.props.click}
            center
          />
        </div>
      </div>
    )
  }
}

export default InfoPopup



// WEBPACK FOOTER //
// ./src/app/shared/components/InfoPopup/index.js